import { create } from 'zustand';
import { sendClients, sendClientUpsert, sendClientRemove, sendClientsSelected } from '../channels/clientsChannel';
import { useAuthStore } from './useAuthStore';

function sortClients(clientes = []) {

    return [...clientes].sort((a, b) =>
        String(a.label).localeCompare(
        String(b.label),
        'pt-BR'
        )
    );
}

function buildClientsState(clientes = []) {
    
    const sorted = sortClients(clientes);

    return {
        clientesDisponiveis: sorted,

        clientesDisponiveisMap: new Map(
        sorted.map(cliente => [
            String(cliente.id),
            cliente
        ])
        )
    };

}


function buildAllowClientes(clientesSelecionados) {

    return clientesSelecionados === null
        ? null
        : new Set(
            (clientesSelecionados || []).map(String)
        );

}

function getClientesSelecionados() {

    try {

        const saved = localStorage.getItem('clientesSelecionados');

        return saved
            ? JSON.parse(saved)
            : null;

    } catch {

        return null;

    }

}

function saveClientesSelecionados(clientesSelecionados) {

    try {

        if (clientesSelecionados === null) {

            localStorage.removeItem('clientesSelecionados');

            return;
        }

        localStorage.setItem('clientesSelecionados', JSON.stringify(clientesSelecionados));

    } catch {}

}

const initialClientesSelecionados = getClientesSelecionados();

export const useClientsStore = create((set) => ({

    clientesDisponiveis: [],
    clientesDisponiveisMap: new Map(),

    clientesSelecionados: initialClientesSelecionados,

    allowClientes: buildAllowClientes(initialClientesSelecionados),

    setClientesSelecionados: (clientesSelecionados, broadcast = true) => {

        saveClientesSelecionados(clientesSelecionados);

        set({
            clientesSelecionados,

            allowClientes: buildAllowClientes(clientesSelecionados)
        });

        if(broadcast){

            sendClientsSelected(clientesSelecionados);

        }

    },

    setClientes: (clientes = [], broadcast = true) => {

        set((state) => {

            let clientesSelecionados = state.clientesSelecionados;

            if (!useAuthStore.getState().user?.capabilities?.canSelectClients) {

                const idsDisponiveis = new Set(
                    clientes.map(cliente => Number(cliente.id))
                );

                if (!clientesSelecionados?.length) {

                    clientesSelecionados = [...idsDisponiveis];

                } else {

                    clientesSelecionados = clientesSelecionados
                        .map(Number)
                        .filter(id => idsDisponiveis.has(id));

                    if (!clientesSelecionados.length) {
                        clientesSelecionados = [...idsDisponiveis];
                    }

                }

                saveClientesSelecionados(clientesSelecionados);

            }

            return {
                ...buildClientsState(clientes),
                clientesSelecionados,
                allowClientes: buildAllowClientes(clientesSelecionados)
            };

        });

        if (broadcast) {
            sendClients(clientes);
        }

    },

    upsertCliente: (cliente, broadcast = true) => {

        if (!cliente?.id) {
            return;
        }

        set((state) => {

            const map = new Map(state.clientesDisponiveisMap);

            map.set(
                String(cliente.id),
                cliente
            );

            return buildClientsState(
                Array.from(map.values())
            )

        });

        if (broadcast) {
                
            sendClientUpsert(cliente);

        }

    },

    removeCliente: (clienteId, broadcast = true) => {

        if (!clienteId) {
            return;
        }

        set((state) => {

            const map = new Map(state.clientesDisponiveisMap);

            map.delete(String(clienteId));

            return buildClientsState(
                Array.from(map.values())
            );

        });

        if (broadcast) {
                
            sendClientRemove(clienteId);

        }

    },

    resetClientes: () =>
        set({
            clientesDisponiveis: [],
            clientesDisponiveisMap: new Map()
        })

}));